export default __webpack_public_path__ + "static/media/28e830078a71c356b344c6ec9230b7ca1582036361180.418fb923.webp";